export function currencyFormatter(value) {
  return new Intl.NumberFormat("pt-BR", {
    maximumSignificantDigits: 3,
    style: "currency",
    currency: "BRL",
  }).format(value);
}
